const AUTH_HANDOFF = "spoton-auth-handoff";

/** New tabs don't inherit sessionStorage; stash then restore before React boots. */
export function takeAuthHandoff() {
  try {
    const raw = localStorage.getItem(AUTH_HANDOFF);
    if (!raw) return;
    const bag = JSON.parse(raw);
    Object.keys(bag || {}).forEach((k) => sessionStorage.setItem(k, bag[k]));
    setTimeout(() => {
      try { localStorage.removeItem(AUTH_HANDOFF); } catch (_) { /* ignore */ }
    }, 3000);
  } catch (_) { /* ignore */ }
}

export function openAuthedTab(path) {
  const bag = {};
  for (let i = 0; i < sessionStorage.length; i++) {
    const k = sessionStorage.key(i);
    bag[k] = sessionStorage.getItem(k);
  }
  try {
    localStorage.setItem(AUTH_HANDOFF, JSON.stringify(bag));
  } catch (_) { /* ignore */ }
  window.open(`${window.location.origin}${path}`, "_blank");
}

const localStoreUtil = {
  store_data: (key, data) => {
    if (typeof data === "object") {
      sessionStorage.setItem(key, JSON.stringify(data));
    } else {
      sessionStorage.setItem(key, data);
    }

    return true;
  },

  get_data: (key) => {
    const item = sessionStorage.getItem(key);
    if (!item) return;
    return item;
  },

  remove_data: (key) => {
    sessionStorage.removeItem(key);
    return true;
  },

  remove_all: () => {
    sessionStorage.clear();
    return true;
  },
};

export default localStoreUtil;
